import { useTranslation } from 'react-i18next'
import { Modal } from './../Modals/Modal'
import './Alert.scss'

interface AlertProps {
  onClose: () => void
  visible: boolean
  title: string
  message: string
}

export default function Alert(props: AlertProps) {
  const { t } = useTranslation()

  return (
    <Modal title={props.title} onClose={props.onClose} visible={props.visible} hideCloseIcon>
      <div className="alertArea">
        <i className="alert-icon icon-warning" />
        <div className="alert-message">{props.message}</div>
        <div className="modal-bottom">
          <button title={t('OK')!} onClick={props.onClose}>
            {t('OK')!}
          </button>
        </div>
      </div>
    </Modal>
  )
}
